import {path} from '../../src/utils';
const { getAppEnv } = require('../../config/env');
const env = getAppEnv();

export const getCookie = (req,key) => {
  return path(req.cookies,key,'')
}

export const buildAccessToken = (key,secret,token,email) => {
  const encodedString = encodeBase64([key,secret,token,email,'Owner_Portal_User'].join(':'))
  // console.log('to encode',[key,secret,token,email,'Owner_Portal_User'].join(':'))
  // console.log(encodedString)
  return encodedString
}

export const encodeBase64 = (str) => {
  return new Buffer(str).toString('base64');
}